// Projects page scroll behavior
document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;

  if (!body.classList.contains('projects-page')) return;

  const threshold = window.innerHeight * 0.24;

  const handleScroll = () => {
    if (window.scrollY > threshold) {
      body.classList.remove('projects-on-top');
    } else {
      body.classList.add('projects-on-top');
    }
  };

  window.addEventListener('scroll', handleScroll);
  handleScroll(); // Check initial state
});
